function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@ori-ui/components';
import { Box, styled } from '@ori-ui/mui';
import { Apple, Facebook, Vkontakte, WechatRing } from '@ori-ui/social-icons';
import { Localization } from '../../Localization';
import { TranslationKey } from '../../models';
import { GoogleIcon } from './GoogleIcon';
var socialMediaConfig = {
    facebook: {
        icon: /*#__PURE__*/ _jsx(Facebook, {
            fontSize: "inherit"
        }),
        localizationKey: 'socialNetworkFacebook'
    },
    google: {
        icon: /*#__PURE__*/ _jsx(GoogleIcon, {}),
        localizationKey: 'socialNetworkGoogle'
    },
    vkontakte: {
        icon: /*#__PURE__*/ _jsx(Vkontakte, {
            fontSize: "inherit"
        }),
        localizationKey: 'socialNetworkVKontakte'
    },
    wechat: {
        icon: /*#__PURE__*/ _jsx(WechatRing, {
            fontSize: "inherit"
        }),
        localizationKey: 'socialNetworkWeChat'
    },
    apple: {
        icon: /*#__PURE__*/ _jsx(Apple, {
            fontSize: "inherit"
        }),
        localizationKey: 'socialNetworkApple'
    }
};
var ButtonStyled = styled(Button)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0),
        width: '100%',
        height: '46px',
        maxWidth: '330px',
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center'
    };
});
var IconStyled = styled('div')(function(param) {
    var ownerState = param.ownerState;
    return {
        width: '48px',
        height: '44px',
        display: 'flex',
        fontSize: '33px',
        justifyContent: 'center',
        alignItems: 'center',
        '& svg': _object_spread({}, ownerState.providerName === 'facebook' && {
            color: '#1877f2'
        }, ownerState.providerName === 'vkontakte' && {
            color: '#44668f'
        }, ownerState.providerName === 'wechat' && {
            color: '#2cbb00'
        })
    };
});
export var getSocialMedia = function(mediaProviderName) {
    var config = socialMediaConfig[mediaProviderName];
    if (!config) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(ButtonStyled, {
        variant: "outlined",
        children: [
            /*#__PURE__*/ _jsx(IconStyled, {
                ownerState: {
                    providerName: mediaProviderName
                },
                children: config.icon
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    textTransform: 'initial'
                },
                children: /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: TranslationKey[config.localizationKey],
                    id: TranslationKey[config.localizationKey]
                })
            })
        ]
    });
};
